import React from "react"

export default function Footer() {
    return (
        <div className="footer">
            <a href="https://lupussolutions.netlify.app" target="_blank" rel="noopener noreferrer">Powered by: Lupus Solutions</a>
            <a id="policy" href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        </div>
    )
}